import api from "./api";
import {
    LOGIN_SUCCESS,
    LOGIN_REQUEST,
    LOGIN_FAIL,
    LOGIN_RESET,

    CREATE_VERIFICATION_REQUEST,
    CREATE_VERIFICATION_SUCCESS,
    CREATE_VERIFICATION_FAIL,
    CREATE_VERIFICATION_RESET,

    VERIFY_OTP_REQUEST,
    VERIFY_OTP_SUCCESS,
    VERIFY_OTP_FAIL,
    VERIFY_OTP_RESET,

    GET_USER_ACCESS_LEVEL_REQUEST,
    GET_USER_ACCESS_LEVEL_SUCCESS,
    GET_USER_ACCESS_LEVEL_FAIL,
    GET_USER_ACCESS_LEVEL_RESET,

    GET_USER_MFA_DETAILS_REQUEST,
    GET_USER_MFA_DETAILS_SUCCESS,
    GET_USER_MFA_DETAILS_FAIL,
    GET_USER_MFA_DETAILS_RESET,

    LOGOUT, MFA_TRUST_REQUEST, MFA_TRUST_SUCCESS, MFA_TRUST_FAIL
} from "../constants/LoginConstants"
import {Http, DbPathHelper} from "../services";
import {ACCESS_TOKEN, AUTH_EMPLOYEEID, AUTH_USERNAME, CLIENTS, INITIAL_TOKEN, SU_MANAGEMENT} from "../constants";
import {jwtDecode} from "jwt-decode";
import axios from "axios";
import store from "../store";

const url = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5132/api';

export const login = (UserName, Password) => async (dispatch) => {
    try {
        dispatch({
            type: LOGIN_REQUEST
        })

        const {data} = await Http.post(
            DbPathHelper.getLoginPath(),
            {UserName, Password},
            {'Content-type': 'multipart/form-data'}
        )

        if (data.success) {
            localStorage.setItem('clients', JSON.stringify(data.data.clients))

            dispatch({
                type: LOGIN_SUCCESS,
                payload: data
            })
        } else {
            console.log("ERROR: ", data.status)
            dispatch({
                type: LOGIN_FAIL,
                payload: data.message,
            })
        }

    } catch (error) {
        dispatch({
            type: LOGIN_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}

export const loginSilent = (peoId, key, history, setIsLoginSilent) => async () => {
    try {
        const {data} = await Http.post(
            DbPathHelper.getLoginSsoPath(),
            {peoId, key},
            {'Content-type': 'multipart/form-data'}
        )

        if (data.success) {
            if (data.data?.signInStage === SU_MANAGEMENT) {
                const decoded = jwtDecode(data.data.token);

                localStorage.setItem(ACCESS_TOKEN, JSON.stringify(data.data.token));
                localStorage.setItem(AUTH_USERNAME, decoded?.UserName)
                localStorage.setItem(AUTH_EMPLOYEEID, decoded?.UserId)
                localStorage.removeItem(INITIAL_TOKEN);
                window.location.href = "/super-admin-management";
            }
            else {
                localStorage.setItem(INITIAL_TOKEN, JSON.stringify(data.data.token))
                localStorage.setItem(CLIENTS, JSON.stringify(data.data.clients))
                history('/client');
            }
            setIsLoginSilent(false);
        } else {
            history('/sign-in');
            setIsLoginSilent(false);
        }
    } catch (error) {
        history('/sign-in');
        setIsLoginSilent(false);
    }
}

export const createVerification = (Channel) => async (dispatch) => {
    try {
        dispatch({
            type: CREATE_VERIFICATION_REQUEST
        })

        const config = {
            headers: {
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem(INITIAL_TOKEN))}`,
                'Content-type': 'multipart/form-data',
            }
        }
        const {data} = await api.post(`${url}${DbPathHelper.getSendOtpPath()}`, {Channel}, config)

        dispatch({
            type: CREATE_VERIFICATION_SUCCESS,
            payload: data.success
        })
    } catch (error) {
        dispatch({
            type: CREATE_VERIFICATION_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}
export const verifyOtp = (Code) => async (dispatch) => {
    try {
        dispatch({
            type: VERIFY_OTP_REQUEST
        })

        const config = {
            headers: {
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem(INITIAL_TOKEN))}`,
                'Content-type': 'multipart/form-data',
            }
        }
        const {data} = await api.post(`${url}${DbPathHelper.getVerifyOtpPath()}`, {Code}, config)

        dispatch({
            type: VERIFY_OTP_SUCCESS,
            payload: data.data
        })
    } catch (error) {
        dispatch({
            type: VERIFY_OTP_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}

export const mfaTrust = (RememberDays) => async (dispatch, history) => {
    try {
        dispatch({
            type: MFA_TRUST_REQUEST
        })

        const token = localStorage.getItem(INITIAL_TOKEN)
            ? JSON.parse(localStorage.getItem(INITIAL_TOKEN))
            : JSON.parse(localStorage.getItem(ACCESS_TOKEN))

        const config = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-type': 'multipart/form-data',
            }
        }

        const {data} = await api.post(`${url}${DbPathHelper.getMfaTrustPath()}`, {RememberDays}, config)

        if (data.success) {
            const accessToken = localStorage.getItem(ACCESS_TOKEN);

            if (accessToken) {
                window.location.href = "/dashboard";
            }

            dispatch({
                type: MFA_TRUST_SUCCESS,
                payload: data.data
            })
        }
    } catch (error) {
        dispatch({
            type: MFA_TRUST_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}

export const getUserAccessLevel = (ClientId) => async (dispatch) => {
    try {
        dispatch({
            type: GET_USER_ACCESS_LEVEL_REQUEST
        })

        const token = localStorage.getItem(INITIAL_TOKEN)
            ? JSON.parse(localStorage.getItem(INITIAL_TOKEN))
            : JSON.parse(localStorage.getItem(ACCESS_TOKEN))

        const config = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-type': 'multipart/form-data',
                'TimezoneOffset': new Date().getTimezoneOffset()
            }
        }

        const {data} = await api.post(`${url}${DbPathHelper.getSelectClientPath()}`, {ClientId}, config)

        if (data.success === true) {
            dispatch({
                type: GET_USER_ACCESS_LEVEL_SUCCESS,
                payload: data.success,
                result: data.data
            })
        }

    } catch (error) {
        dispatch({
            type: GET_USER_ACCESS_LEVEL_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}
export const getUserMfaDetails = () => async (dispatch, getState) => {
    try {
        dispatch({
            type: GET_USER_MFA_DETAILS_REQUEST
        })

        const config = {
            headers: {
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem(INITIAL_TOKEN))}`,
                'TimezoneOffset': new Date().getTimezoneOffset()
            }
        }

        const {data} = await api.get(`${url}${DbPathHelper.getUserMfaDetailsPath()}`, config)

        if (data.success === true) {
            dispatch({
                type: GET_USER_MFA_DETAILS_SUCCESS,
                payload: data.data
            })
        }

        if (data.success === false) {
            dispatch({
                type: GET_USER_MFA_DETAILS_FAIL,
                payload: data.success,
            })
        }
    } catch (error) {
        dispatch({
            type: GET_USER_MFA_DETAILS_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}
export const resetLogin = () => async (dispatch, getState) => {
    dispatch({
        type: LOGIN_RESET,
    })
};
export const resetVerification = () => async (dispatch, getState) => {
    dispatch({
        type: CREATE_VERIFICATION_RESET,
    })
};
export const resetVerifyOtp = () => async (dispatch, getState) => {
    dispatch({
        type: VERIFY_OTP_RESET,
    })
};
export const resetGetUserAccessLevel = () => async (dispatch, getState) => {
    dispatch({
        type: GET_USER_ACCESS_LEVEL_RESET,
    })
};
export const resetGetUserMfaDetails = () => async (dispatch, getState) => {
    dispatch({
        type: GET_USER_MFA_DETAILS_RESET,
    })
};
export const logout = () => (dispatch) => {
    handleLogout();
    localStorage.removeItem(INITIAL_TOKEN)
    localStorage.removeItem('access_token')
    localStorage.removeItem('userName')
    localStorage.removeItem('employeeId')
    localStorage.removeItem('personalEmail')
    localStorage.removeItem('workEmail')
    localStorage.removeItem('mobilePhone')
    localStorage.removeItem('isSuperAdmin')
    localStorage.removeItem('clients')
    localStorage.removeItem('roleAccessLevels')
    localStorage.removeItem('isPayrollEnable')
    localStorage.removeItem('isLettersEnable')
    localStorage.removeItem('isDocumentsEnable')
    localStorage.removeItem('isProcessesEnable')
    localStorage.removeItem('IsTrainingEnable')
    localStorage.removeItem('client_name')
    localStorage.removeItem('client_name')
    localStorage.removeItem('client_id')
    localStorage.removeItem('letters-notices')
    localStorage.removeItem('processes')
    localStorage.removeItem('mfa_verify')
    localStorage.removeItem('code_verify')
    dispatch({type: LOGOUT})
}

const handleLogout = () => {
    axios.post(
        `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:5132/api'}/Token/Logout`,
        {},
        { withCredentials: true }
    );
};


